<template>
    <div class="paywall__wrap">
        <div class="row px-3">
            <div class="col-12 ps-0 pe-0 pr-lg-3">
                <h2 class="conteudo-exclusivo-titulo m-0 pb-0">{{titulo}}</h2>
            </div>
            <div class="col-12">
                <h6 class="conteudo-exclusivo-subtitulo"> {{subTitulo}} <span class="txt-w-bold c-pointer" @click="showModalLogin = !showModalLogin"> {{textoContratacao}} </span></h6>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col-12 conteudo-exclusivo-cadastrese ">
                        <h3 class="align-middle text-center my-5">
                            <a href="/">
                                <img src="../assets/img/Logo.png" alt="Logo Sollicita">
                            </a>
                        </h3>

                        <h3 class="align-middle text-center my-5">
                            {{textoPrincipal}}
                        </h3>
                        <!--<h3 class="align-middle text-center m-5">
                        <a :href="linkBotao" class="btn btn-outline-primary botao_alternativo botao_alternativo_sem-margem botao_alternativo_borda-amarelo"> {{textoBotao}} </a>
                    </h3>-->
                    </div>
                    <div class="col-12">
                        <div class="row sessao-planos">
                            <div class="col-12 col-md-6">
                                <div class="box-planos">
                                    <span class="titulo mb-4">Assinatura Pessoa Física</span>
                                    <span class="valor">R$ 29,90 <span class="mes">mês.</span> </span>
                                    <button class="btn btn-block btn-assine mt-2" @click="assinaturaFisica">Assine</button>
                                    <hr class="divisor" />
                                    <div class="detalhes">
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Conteúdo jornalístico exclusivo</p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Vídeos com entrevistas</p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Rede social exclusiva.</p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Acesso a <strong>5</strong> ferramentas de gestão</p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Acesso a Revista digital O Pregoeiro.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 mt-3 mt-sm-0">
                                <div class="box-planos">
                                    <span class="titulo mb-4">Assinatura Pessoa Jurídica</span>
                                    <span class="valor">Preço sob consulta </span>
                                    <button class="btn btn-block btn-assine mt-2" @click="assinaturaJuridica">Solicite contato e experimente agora.</button>
                                    <hr class="divisor" />
                                    <div class="detalhes">
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Conteúdo jornalístico exclusivo </p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Vídeos com entrevistas</p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Rede social exclusiva.</p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Acesso a <strong>9</strong> ferramentas de gestão</p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> E ainda vídeos de Capacitação dos eventos NP</p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Orientações Técnicas</p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Acesso a Revista digital O Pregoeiro </p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Acesso a Revista digital Negócios Públicos </p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Acesso a Revista digital Governança Pública </p>
                                        <p class="linha-detalhes"><i class="fas fa-check mr-2"></i> Acesso a Revista digital Licicon. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-12 text-center mt-4">
                                <p class="mb-0">Ofertas válidas apenas para novos assinantes.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <ModalLogin :showModal="showModalLogin" :hideModal="hideModalLogin" :logou="logou"></ModalLogin>
    </div>
</template>

<script>
    import ModalLogin from '@/components/ModalLogin'

    export default {
        name: 'ConteudoExclusivo',
        components: { ModalLogin },
        props: {
            titulo: {
                type: String,
                default: 'Conteúdo exclusivo'
            },
            subTitulo: {
                type: String,
                default: 'Para continuar a ler, faça '        
            },
            linkContratacao: {
                type: String,
                default: '/Planos/'    
            },
            textoContratacao: {
                type: String,
                default: 'login'    
            },
            textoPrincipal: {
                type: String,
                default: 'Faça sua assinatura e tenha acesso completo ao conteúdo.'                    
            },
            linkBotao:{
                type: String,
                default: '/Planos/'    
            },
            textoBotao: {
                type: String,
                default: 'ASSINE AGORA'    
            },
            liberaConteudo: {
                type: Function,
                required: true,
            }
        },
        data: function () {
            return {
                showModalLogin: false,
                hideModalLogin: false,
            }
        },
        methods: {
            assinaturaFisica() {
                window.open('https://pay.hotmart.com/X6562841I?off=g0qncg1g&checkoutMode=0&bid=1602852032215', '_blank');
            },

            assinaturaJuridica(){
                window.open('https://sollicita.com.br/Planos', '_blank');
            },

            logou() {
                this.hideModalLogin = !this.hideModalLogin;
                this.liberaConteudo();
            },
        }
    }
</script>

<style lang="scss">
    /* CONTEUDO EXCLUSIVO*/

    .sessao-planos{
        background-color: #ededed;
        padding: 20px 0;
    }

    .sessao-planos .box-planos{
        background-color: #fff;
        border-radius: 8px;
        padding: 20px;        
    }

    .sessao-planos .box-planos .btn-assine{
        background-color: #feb811;
        color: #fff;
    }

    .sessao-planos .box-planos .titulo{
        font-weight: 500;
        font-family: 'Roboto';
        font-size: 1.5rem;
        display: flex;
    }
    .sessao-planos .box-planos .valor{
        font-size: 1.7rem;
        font-weight: 600;
    }
    .sessao-planos .box-planos .valor .mes{
        font-size: 1rem;
        font-weight: normal;
    }

    .sessao-planos .box-planos .divisor{
        margin-top: 1.5rem;
    }

    .sessao-planos .box-planos .detalhes .linha-detalhes{

    }

    .sessao-planos .box-planos .detalhes .linha-detalhes .fa-check{
        color: #00924c;
    }

    /* ------------- */
    .paywall__wrap {
        margin: 0;
        padding: 0 !important;
        position: relative;
        display: inline-block;
    }

        .paywall__wrap:before {
            background: linear-gradient(hsla(0,0%,100%,0),#fff 70%);
            content: "";
            display: block;
            height: 12.5rem;
            left: 0;
            pointer-events: none;
            position: absolute;
            right: 0;
            top: 0;
            transform: translateY(-100%);
        }

        .conteudo-exclusivo-titulo {
        text-align: center;
        color: #00518C;
        letter-spacing: 2px;
        border-top: solid 2px #FCBB00;
        border-width: 3px;
        padding: 20px;
        font-weight: 600;
    }

    .conteudo-exclusivo-subtitulo a {
        color: #00518C;
        font-weight: 600;
    }

    .conteudo-exclusivo-subtitulo {
        text-align: center;
        color: #00518C;
        padding: 20px;
        font-weight: 100;
    }

    .conteudo-exclusivo-cadastrese:after {
        position: absolute;
        content: " ";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        background-color: rgba(0,81,140, 0.5);
    }

    .conteudo-exclusivo-cadastrese {
        background: url(~@/assets/img/assinatura-sollicita.jpg) no-repeat 0, 0;
        height: auto;
        width: 280px;
        background-position: bottom;
        position: relative;
        background-size: cover;
    }

        .conteudo-exclusivo-cadastrese h3 {
            color: #fff;
            z-index: 1;
            position: inherit;
        }

        .botao_alternativo {
        color: #02568c;
        font-weight: 900;
        font-size: 12px;
        background: #fff;
        padding: .6rem 1.3rem;
        margin: 1.5rem auto;
        display: block;
        min-width: 160px;
        text-align: center;
        &:hover

    {
        color: #fff !important;
        background-color: #02568c;
        border-color: none;
    }

    }
    .botao_alternativo_sem-margem {
        margin-left: 0;
    }

    .botao_alternativo {
        color: #02568c !important;
        border-color: #02568c !important;
        font-weight: 900 !important;
        font-size: 12px !important;
        padding: .6rem 1.3rem !important;
        margin: 1.5rem auto !important;
        display: block !important;
        min-width: 160px !important;
        text-align: center !important;
    }
    .botao_alternativo_borda-amarelo {
        background-color: transparent;
        border-color: #feb811 !important;
        color: #fff !important;
    }

        .botao_alternativo_borda-amarelo:hover {
            background-color: #feb811 !important;
            border-color: #fff !important;
            color: #fff !important;
        }

    @media only screen and (max-width: 65em) {
        .botao_alternativo {
            width: 100%;
            margin: 20px 0 !important;
            margin: 0 auto;
            height: auto;
            line-height: 1.6rem;
            font-size: 0.8rem;
        }

        a.btn.btn-outline-primary.botao_alternativo.botao_alternativo_sem-margem.botao_alternativo_borda-amarelo { /* botao mais livros/revistas */
            margin: 0px !important;
        }

    }

</style>